export function txtWrapping() {
  $('.js-txt_wrapping').children().addBack().contents().each(function () {
    if (this.nodeType == 3) {
      $(this).replaceWith($(this).text().replace(/(\S)/g, '<span class="c-txt_wrapping_wrapper"><span class="c-txt_wrapping">$&</span></span>'));
    }
  });
}